import React from 'react';

type BadgeVariant =
  | 'success'
  | 'warning'
  | 'error'
  | 'info'
  | 'default'
  | 'rules'
  | 'protected'
  | 'active'
  | 'inactive'
  | 'plan-free'
  | 'plan-pro'
  | 'plan-business';

interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  size?: 'sm' | 'md';
  className?: string;
}

export function Badge({ children, variant = 'default', size = 'md', className = '' }: BadgeProps) {
  const variants: Record<BadgeVariant, string> = {
    // Status variants - high contrast
    success: 'bg-[--clinqr-primary] text-[--clinqr-bg]',
    warning: 'bg-amber-50 text-amber-900 border border-amber-200',
    error: 'bg-red-50 text-red-900 border border-red-200',
    info: 'bg-sky-50 text-sky-900 border border-sky-200',
    default: 'bg-[--clinqr-bg-subtle] text-[--clinqr-text-primary] border border-[--clinqr-border]/10',

    // QR Code specific
    rules: 'bg-[--clinqr-primary] text-[--clinqr-bg]',
    protected: 'bg-red-50 text-red-900 border border-red-200',
    active: 'bg-[--clinqr-primary] text-[--clinqr-bg]',
    inactive: 'bg-[--clinqr-bg-subtle] text-[--clinqr-text-muted] border border-[--clinqr-border]/10',

    // Plan badges
    'plan-free': 'bg-[--clinqr-bg-subtle] text-[--clinqr-text-primary] border border-[--clinqr-border]/10',
    'plan-pro': 'bg-[--clinqr-primary] text-[--clinqr-bg]',
    'plan-business': 'bg-[--clinqr-primary] text-[--clinqr-bg]',
  };

  const sizes = {
    sm: 'px-1.5 py-0.5 text-xs',
    md: 'px-2 py-1 text-xs',
  };

  return (
    <span
      className={`inline-flex items-center justify-center gap-1 font-medium rounded-full ${variants[variant]} ${sizes[size]} ${className}`}
    >
      {children}
    </span>
  );
}
